import React, { ReactElement } from 'react';
import { makeStyles } from 'tss-react/mui';

import { EarnMore } from '../../components/EarnMore';
import { Faq } from '../../components/Faq';
import { MyStake } from '../../components/MyStake';
import { StakeUnstake } from '../../components/StakeUnstake';
import { Stats } from '../../components/Stats';

export function Dashboard(): ReactElement {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Stats />

      <div className={classes.content}>
        <MyStake />

        <div className={classes.main}>
          <StakeUnstake />
        </div>

        <EarnMore />
      </div>

      <Faq />
    </div>
  );
}

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(12),

    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(6),
    },
  },
  content: {
    display: 'grid',
    gap: theme.spacing(5, 8),
    gridTemplateColumns: '1fr 1fr',

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(6),
    },
  },
  main: {
    gridRow: 'span 2',
    height: '100%',
  },
}));
